import styled from 'styled-components'

export const ManagementEmptyTitleUi = styled.div`
  margin-bottom: 15px;
  color: #414355;
  font-size: 15px;
`
